export const PORTAL_LANDING_SECTIONS = [
	"roadmap",
	"docs",
	"changelog",
	"support",
] as const

export type PortalLandingSection = (typeof PORTAL_LANDING_SECTIONS)[number]

export type PortalLanding =
	| { kind: "section"; section: PortalLandingSection }
	| { kind: "tab"; tabId: string }

const TAB_PREFIX = "tab:"
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i

/** Null for an unset or unrecognised value, which keeps the default section order. */
export function parsePortalLanding(
	value: string | null | undefined,
): PortalLanding | null {
	if (!value) return null
	if (value.startsWith(TAB_PREFIX)) {
		const tabId = value.slice(TAB_PREFIX.length)
		return UUID.test(tabId) ? { kind: "tab", tabId } : null
	}
	return (PORTAL_LANDING_SECTIONS as readonly string[]).includes(value)
		? { kind: "section", section: value as PortalLandingSection }
		: null
}

export function portalLandingValue(landing: PortalLanding): string {
	return landing.kind === "tab"
		? `${TAB_PREFIX}${landing.tabId}`
		: landing.section
}

export const isPortalLandingValue = (value: string): boolean =>
	parsePortalLanding(value) !== null

/** Null and undefined pass: null resets to the default order, undefined leaves it. */
export function assertPortalLandingValue(value: string | null | undefined) {
	if (value != null && !isPortalLandingValue(value)) {
		throw new Error(`Unknown portal landing page: ${value}`)
	}
}
